import { ArrowUpRight } from "lucide-react"
import { memo } from "react"

import { cn } from "@/shared/utils"

type HeroActionsProps = {
  primaryLabel: string
  primaryHref: string
  primaryExternal?: boolean
  secondaryLabel: string
  secondaryHref: string
}

export const HeroActions = memo(function HeroActions({
  primaryLabel,
  primaryHref,
  primaryExternal = false,
  secondaryLabel,
  secondaryHref,
}: HeroActionsProps) {
  const primaryRel = primaryExternal ? "noopener noreferrer" : undefined
  const primaryTarget = primaryExternal ? "_blank" : undefined

  return (
    <div
      className="flex w-full flex-col items-stretch gap-3 motion-safe:animate-float-in motion-safe:[animation-delay:240ms] sm:w-auto sm:flex-row sm:items-center sm:justify-center sm:gap-4 lg:justify-start"
    >
      <a
        href={primaryHref}
        target={primaryTarget}
        rel={primaryRel}
        className={cn(
          "group inline-flex h-11 cursor-pointer items-center justify-center gap-2 rounded-xl px-7",
          "bg-mesa-primary text-[13px] font-medium tracking-wide text-primary-foreground",
          "shadow-[0_1px_2px_rgba(11,26,59,0.08),0_8px_24px_rgba(11,26,59,0.16)]",
          "transition-all duration-300 ease-out hover:bg-mesa-primary-alt hover:shadow-[0_1px_2px_rgba(11,26,59,0.08),0_12px_32px_rgba(11,26,59,0.22)]",
        )}
      >
        {primaryLabel}
        <ArrowUpRight
          className="h-4 w-4 transition-transform duration-300 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          aria-hidden="true"
        />
      </a>

      <a
        href={secondaryHref}
        className={cn(
          "group inline-flex h-11 cursor-pointer items-center justify-center gap-2 rounded-xl border border-mesa-border bg-card/60 px-5 backdrop-blur-sm",
          "text-[13px] font-medium tracking-wide text-mesa-primary/85",
          "transition-all duration-300 ease-out hover:border-mesa-primary/20 hover:bg-card hover:text-mesa-primary sm:border-transparent sm:bg-transparent sm:backdrop-blur-none sm:hover:border-transparent sm:hover:bg-transparent",
        )}
      >
        {secondaryLabel}
        <ArrowUpRight
          className="h-4 w-4 transition-transform duration-300 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          aria-hidden="true"
        />
      </a>
    </div>
  )
})
